import { render } from "./PublicRsvp.vue?vue&type=template&id=638940ba&scoped=true"
import script from "./PublicRsvp.vue?vue&type=script&lang=js"
export * from "./PublicRsvp.vue?vue&type=script&lang=js"

import "./PublicRsvp.vue?vue&type=style&index=0&id=638940ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638940ba"]])

export default __exports__